export const CONFIG = {
    client_name : "westenergie",
    client_display_name : "Westenergie",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : `https://esr.fe-bis.de/de/westenergie/`,
    plz_validation : (plz : string) => plz.length == 5,
    plz_default : "12345",
    foerderung : true,
    show_funding_list: false,
    development_mode: false,
}